import { getBrowserFeature } from '../../utils';
import { listenForViewportChange } from './listenForViewportChange';
import { getWindowBounds } from './getWindowBounds';
const hookInitValues = getWindowBounds();
let bounds = hookInitValues;
const listeners = new Set();
let globalListenersAttached = false;
let virtualKeyboardHeight = 0;
let removeGlobalListeners;
const emitChange = ()=>{
    listeners.forEach((listener)=>listener());
};
const syncBounds = ()=>{
    const windowBounds = getWindowBounds();
    const next = {
        width: windowBounds.width,
        height: windowBounds.height - virtualKeyboardHeight
    };
    if (next.width === bounds.width && next.height === bounds.height) {
        return;
    }
    bounds = next;
    emitChange();
};
const updateBoundsOnGeometryChange = (event)=>{
    virtualKeyboardHeight = event.target.boundingRect.height;
    syncBounds();
};
const attachGlobalListeners = ()=>{
    if (globalListenersAttached || typeof window === 'undefined') {
        return;
    }
    globalListenersAttached = true;
    const { virtualKeyboard } = getBrowserFeature();
    const { addListener, removeListener } = listenForViewportChange(syncBounds);
    syncBounds();
    addListener();
    virtualKeyboard?.addEventListener('geometrychange', updateBoundsOnGeometryChange);
    removeGlobalListeners = ()=>{
        removeListener();
        virtualKeyboard?.removeEventListener('geometrychange', updateBoundsOnGeometryChange);
    };
};
export const subscribeToBounds = (onStoreChange)=>{
    attachGlobalListeners();
    listeners.add(onStoreChange);
    return ()=>{
        listeners.delete(onStoreChange);
        // Detach the global listeners once nothing is observing bounds. The next
        // subscriber re-attaches and re-syncs, so no resize is missed across the gap.
        if (listeners.size === 0) {
            removeGlobalListeners?.();
            removeGlobalListeners = undefined;
            globalListenersAttached = false;
        }
    };
};
export const getBoundsSnapshot = ()=>bounds;
export const getServerBoundsSnapshot = ()=>hookInitValues;
/** Resets module state between unit tests. */ export const resetBoundsStoreForTests = ()=>{
    removeGlobalListeners?.();
    removeGlobalListeners = undefined;
    bounds = getWindowBounds();
    listeners.clear();
    globalListenersAttached = false;
    virtualKeyboardHeight = 0;
};

//# sourceMappingURL=boundsStore.js.map